var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFloor = function SvgFloor(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1209",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M314.38 123.14v25.453c-25.108 0-232.04 1.665-246.32-.476-17.611-2.497-32.843-20.933-31.177-40.914 2.856-34.849 34.509-36.514 61.64-36.514h248.94V43.81h-183.13c-29.987 0-60.807-.594-90.794.12-55.571 1.189-84.249 60.895-53.191 104.31 13.566 19.148 31.177 27.355 64.972 27.236h182.9c32.248 0 58.784 4.163 72.587-18.078 15.469-24.739 1.666-60.896-19.634-60.896l-238.11-.119c-32.724 0-34.39 26.88.833 26.761z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1211",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M278.44 296.2H40.69v-23.074h242.16-4.403c24.037 0 24.037-24.501 0-24.501H51.637c-58.903 0-58.903 73.265 0 73.265h226.81c90.913 0 90.794-124.41 0-124.41H7.497v25.69h270.95c52.953 0 52.953 73.027 0 73.027z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFloor);
export default ForwardRef;